import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { TransactionSubType } from 'src/model/transactionSubType.model';

interface TransactionInterface {
	remark: string;
	amount: number;
	date: Date;
	subtype?: number;
}

@Component({
	selector: 'app-add-expenses',
	templateUrl: './add-expenses.component.html',
	styleUrls: ['./add-expenses.component.scss'],
	standalone: false
})
export class AddExpensesComponent {
	private activeModal = inject(NgbActiveModal);
	private restapi = inject(RestApiService);
	private constructApi = inject(ConstructAPI);
	protected sharedService = inject(SharedService);

	@Input() companyBankAccountList: Account[] = [];
	@Input() cashAccountList: Account[] = [];
	@Output() passEntry = new EventEmitter<any>();
	selectedAccountId: number;
	selectedAccountBalance: number;
	selectedSubTypeId: number;

	@Input() paidByDuitLebih = false;

	//2-WAY BINDING INFO
	@Input() remark: string;
	@Input() amount = 0;
	subtypeList: TransactionSubType[] = [];

	disabledSubmit = false;
	transactionList: TransactionInterface[] = [];

	setSelectedAccount(accountId: number) {
		if (accountId === this.selectedAccountId) return true;
		else return false;
	}

	setSelectedSubType(subTypeID: number) {
		if (subTypeID === this.selectedSubTypeId) return true;
		else return false;
	}

	setExpenseTitle() {
		if (this.paidByDuitLebih == true) return 'Expenses by Duit Lebih';
		else return 'Expenses';
	}

	isFieldNull() {
		// var paymentNull = (this.amount == undefined || this.amount == 0);
		// var remarkNull = (this.remark == undefined || this.remark == "");
		const transactionNull = this.transactionList == undefined || this.transactionList.length == 0;
		const selectedAccountIdNull = this.selectedAccountId == undefined;
		// var paymentValid = isNaN(+this.amount)

		return transactionNull || selectedAccountIdNull;
	}

	getTransactionData(data: TransactionInterface[]) {
		this.transactionList = data;
	}

	addExpenses() {
		this.disabledSubmit = true;

		const data = {
			accountId: Number(this.selectedAccountId),
			transactions: this.transactionList
		};

		const xhr = this.restapi.postRequest(this.constructApi.getAddExpenses(), data);
		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				this.disabledSubmit = false;
				if (xhr.status == 200) {
					window.location.reload();
				} else this.sharedService.openErrorMessage(xhr);
			}
		};
	}

	getAccountBalance() {
		let account = this.companyBankAccountList.find(account => account.ID === Number(this.selectedAccountId));
		if (account == undefined) account = this.cashAccountList.find(account => account.ID === Number(this.selectedAccountId));

		return account.Balance;
	}

	isBalanceInsufficient(balance: number) {
		let expenseTotal = 0;

		for (let i = 0; i < this.transactionList.length; i++) {
			expenseTotal += this.transactionList[i].amount;
		}

		if (this.sharedService.roundTo2Dec(balance) >= this.sharedService.roundTo2Dec(expenseTotal)) return false;
		else return true;
	}

	addExpensesByDuitLebih() {
		this.disabledSubmit = true;

		if (this.selectedSubTypeId == undefined) {
			var data = {
				accountId: Number(this.selectedAccountId),
				transactions: this.transactionList
			};
		}

		const xhr = this.restapi.postRequest(this.constructApi.getAddExtraExpenses(), data);
		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				this.disabledSubmit = false;
				if (xhr.status == 200) {
					window.location.reload();
				} else this.sharedService.openErrorMessage(xhr);
			}
		};
	}

	submit() {
		if (this.isFieldNull()) {
			this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER);
		} else {
			if (this.paidByDuitLebih == true) this.addExpensesByDuitLebih();
			else {
				if (this.getAccountBalance() < this.amount) this.sharedService.openAlert('Expense amount is more than account balance', ALERT_TYPE.DANGER);
				else this.addExpenses();
			}
		}
	}

	reset() {
		this.activeModal.close();
	}
}
